import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
	Out
} from '../../../assets/icons';
import { MOBILE_TABS } from '../../../constants/accesByRolesGroup';

import {
	Wrapper,
	Header,
	Title,
	Subtitle,
	Section,
	Item,
	IconLeft,
	LogoutWrapper,
	LogoutButton,
	Divider
} from './MoreMobile.styled';
import { useLogout } from '../../../hooks/useLogout';
import { logout as logoutAction, setPatientDetails } from '../../../actions';
import { canAccessMenuItem } from '../../../utils/accessControl';

const MoreMobile = (props) => {
	const { auth, patient, setPatientDetails, logoutAction } = props;
	const handleLogout = useLogout(setPatientDetails, logoutAction);

	const getMobileMoreRoutes = () => {
		const userRoles = auth?.gruposRoles || [];
		const mobileTabs = userRoles.flatMap(role => MOBILE_TABS[role] || []);

		const moreRoutes = mobileTabs
			.flatMap(item => (Array.isArray(item.subRoutes) ? item.subRoutes : []))
			.filter(item => canAccessMenuItem(item, auth));

		return moreRoutes.filter(
			(item, index, routes) => routes.findIndex(route => route.path === item.path) === index
		);
	};

	const moreRoutes = getMobileMoreRoutes();

	return (
		<Wrapper>
			<Header>
				<Title>{auth?.nombre ? `${auth.nombre} ${auth?.apellido}` : ''}</Title>
				<Subtitle>{patient?.coberturaMedica ? `Plan ${patient?.coberturaMedica} ${patient?.planLineaCartilla}` : ''}</Subtitle>
			</Header>

			<Section>
				{moreRoutes.map((item, idx, arr) => {
					const Icon = item.icon;
					return (
						<React.Fragment key={item.id}>
							<Item onClick={() => props.history.push(item.path)}>
								<IconLeft>
									<Icon width={25} height={25} color='#000000ff' />
								</IconLeft>
								{item.label}
							</Item>
							{idx < arr.length - 1 && <Divider />}
						</React.Fragment>
					)
				})}
			</Section>

			<LogoutWrapper>
				<LogoutButton onClick={handleLogout}>
					<IconLeft>
						<Out width={20} height={20} />
					</IconLeft>
					Cerrar sesión
				</LogoutButton>
			</LogoutWrapper>
		</Wrapper>
	);
};

function mapStateToProps({ auth, patient }) {
	return { auth, patient }
}

const mapDispatchToProps = {
	setPatientDetails,
	logoutAction
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MoreMobile));
